import React from "react";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter } from "react-router-dom";
import * as ConnectionComps from "@repoflow/components/connection";
import * as AccountComps from "@repoflow/components/account";
import * as NotifyUtils from "@repoflow/form-schema/notify";
import * as ObservabilityComps from "@repoflow/components/observability";
import Routes from "./routes";
import { basename, rum } from "env"

ObservabilityComps.init(rum);

const originalConsoleError = console.error;
console.error = (message, ...args) => {
    if (typeof message === 'string' && message.includes('defaultProps will be removed')) {
        return;
    }
    originalConsoleError.apply(console, [message, ...args])
}

function App() {
      const client = ConnectionComps.get("/api/graphql");

      return (
            <ApolloProvider client={client}>
                  <BrowserRouter basename={basename}>
                        <AccountComps.Provider>
                              <Routes />
                              <NotifyUtils.Handler />
                        </AccountComps.Provider>
                  </BrowserRouter>
            </ApolloProvider>
      );
}

export default App;
